import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

function CS_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <CS_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <CS_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function CS_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What skills are needed to succeed in cybersecurity?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Cybersecurity professionals need a mix of technical skills, such
              as knowledge of network security, cryptography, incident response,
              and penetration testing, as well as soft skills like
              problem-solving, communication, and critical thinking. A solid
              understanding of security frameworks (e.g., NIST, ISO/IEC 27001)
              is also essential.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What certifications are most valuable for a cybersecurity career?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Some widely recognized certifications in the cybersecurity field
              include:
              <ul>
                <li>
                  Certified Information Systems Security Professional (CISSP)
                </li>
                <li>Certified Ethical Hacker (CEH), CompTIA Security+</li>
                <li>Certified Information Security Manager (CISM)</li>
                <li>Certified Information Systems Auditor (CISA)</li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How do I transition to a career in cybersecurity without a
              technical background?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              You can start by learning the basics of IT and cybersecurity
              through online courses or boot camps. Many professionals enter
              cybersecurity from fields like law, compliance, or risk
              management, as cybersecurity also involves governance, risk
              assessment, and policy creation.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
            What types of jobs are available in cybersecurity?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            Cybersecurity offers a wide range of roles, such as:
            <ul>
              <li>Security Analyst, Penetration Tester (Ethical Hacker)</li>
              <li>Incident Responder, Security Architect</li>
              <li>Chief Information Security Officer (CISO), Threat Intelligence Analyst</li>
            </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
            What industries have the most demand for cybersecurity professionals?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            Cybersecurity professionals are needed across various industries, including:
            <ul>
              <li>Financial services (banks, insurance companies), Healthcare (protecting patient data)</li>
              <li>Government agencies (defending against cyber espionage)</li>
              <li>Technology companies (securing software and cloud infrastructure)</li>
              <li>Retail and e-commerce (protecting payment and customer data)</li>
            </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  )
}
export default CS_FAQ_page
